module.exports = __webpack_public_path__ + "img/no-data-found.cedfcd68.svg";